// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__z9kKz","content":"RecentSearches_content__1if18"};